import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://math-ready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Math Ready Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-brand px-8 py-4 text-center text-sm font-extrabold uppercase leading-none text-white shadow-soft transition-all duration-200 hover:bg-brand-dark hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:px-10 sm:py-5 sm:text-base ${className}`} style={{
    paddingTop: "28px",
    paddingBottom: "28px",
    paddingLeft: "35px",
    paddingRight: "35px",
    marginTop: "10px"
  }} data-id="element-41" data-mp="qkafl2jnmxsb">
      <span className="-mr-[0.12em] tracking-[0.12em]" data-id="element-42" data-mp="35x5ylkf7l054">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-43" data-mp="35yz7759dtufr" />
    </a>;
}